export const LABELS_LANGUAGES = {
  es: {
      nie: 'NIE',
      dni: 'DNI',
      nieOrDni: 'DNI o NIE',
      birthday: 'Fecha de nacimiento',
      expiration: 'Fecha de vencimiento del DNI',
      support: 'Código de soporte',
      phone: 'Teléfono',
      email: 'Email',
      inputEmail: 'Ingresa tu email',
      findExpiration: '¿Dónde la encuentro?',
      send: 'Enviar',
      unknownState: 'Estado desconocido',
      manual: 'Ingresar manualmente',

      warnings: {
        error: 'Error!',
        invalidDni: 'Debes ingresar un DNI válido!',
        invalidNie: 'Debes ingresar un NIE válido!',
        invalidNieOrDni: 'Debes ingresar un DNI o NIE válido!',
        errorSomeData: 'Error en algunos datos',
        noPinService: 'Sin servicio Clave PIN',
        noCirbeService: 'Sin servicio Cirbe',
        noCustomization: 'No se ha configurado la customización del widget para este usuario',
        ocassionalError: 'Estamos detectando errores ocasionales, si no puede completar su solicitud, inténtelo más tarde',
        wrongDni: 'Número de documento incorrecto',
        wrongDniDesc: 'El número de documento ingresado es incorrecto, por favor ingrese otro',
        wrongDate: "Fecha incorrecta",
        wrongDateDesc: "La fecha es incorrecta. Revísalo, por favor",
        wrongSupport: 'Número de soporte inválido!',
        inputSupport: 'Por favor, introduce el código de soporte',
        unknownError: 'Error desconocido: ',
        noSms: 'Sin servicio SMS',
        noSmsDesc: 'El usuario no tiene servicio de SMS, vamos a intentar ingresar por flujo Clave Pin, por favor, rellene los campos necesarios',
        noOtp: 'Todavía no has recibido el OTP. Inténtalo de nuevo cuando lo recibas',
        wrongOtp: 'Código inválido. Por favor, introduzca el código recibido por SMS',
        haveToReadTerms: 'Debes leer los términos y condiciones para poder continuar',
        phoneError: 'Error con el teléfono',
        dontHavePhone: 'No tengo otro teléfono',
        badPhoneSS: 'El teléfono ingresado no coincide con registrado en la Seguridad Social, por favor ingrese otro',
        wrongBirthday: 'Fecha de nacimiento incorrecta',
        inputBirthDay: 'Por favor, introduce la fecha de nacimiento',
        wrongExpiration: 'Fecha de vencimiento incorrecta',
        inputExpiration: 'Por favor, introduce la fecha de vencimiento del documento',
        duplicatedRequest: 'Solicitud duplicada!',
        alreadyHaveRequest: 'Ya existe una solicitud para este cliente.',
        currentRequestStatus: 'Estado de la solicitud actual: ',
        requestNoExist: 'No existe la solicitud',
        noRequests: 'No existen solicitudes activas con el código requerido',
        needMoreData: 'Necesitamos más datos para validar el acceso a las administraciones públicas',
      },
      abandoned: {
      afterWaitingOtpSS: 'Abandonado después de esperar OTP de Seguridad Social',
      afterInvalidOtpSS: 'Abandonado despues de OTP inválido en Seguridad Social',
      afterInvalidOtpAEAT: 'Abandonado despues de OTP inválido en AEAT',
      afterWaitingOtpAEAT: 'Abandonado después de esperar OTP de AEAT'
      },
      loadings: {
      gettingData: 'Obteniendo datos de la solicitud...',
      resendingOtp: 'Reenviando OTP...',
      sendingData: 'Enviando datos..',
      validatingData: 'Validando nuevos datos, espere por favor..',
      validatingAndLoginSS: 'Validando datos y logueandose a Seguridad Social, espere por favor..',
      validatingAndLoginAEAT: 'Validando datos y logueandose a AEAT, espere por favor..',
      resendingRequest: 'Reintentando enviar la solicitud...',
      smsToPin: 'Se ha detectado un número de teléfono incorrecto, vamos a probar por flujo Clave PIN',
      sendingNewPhone: 'Enviando nuevo teléfono, aguarde por favor',
      validatingRequest: 'Validando solicitud, espere por favor..',
      creatingRequest: 'Creando solicitud, espere',
      cancelingRequest: 'Cancelando solicitud...',
      checkingSms: 'Verificando servicio SMS..',
      },
      actions: {
      continue: 'Continuar',
      cancel: 'Cancelar proceso',
      back: 'Volver',
      send: 'Enviar',
      retry: 'Intentarlo nuevamente',
      resend: 'Reenviar',
      next: 'Siguiente',
      clickToFinish: 'Haga click aquí para finalizar',
      newRequest: 'Nueva solicitud',
      gotoCurrentRequest: 'Ir a la solicitud actual'
      },
      otp: {
      requestingOtp: 'Estamos solicitando el código. Por favor, espere un momento.',
      otpSentToNumber: 'El código ha sido enviado al teléfono acabado en',
      requestingCode: 'Estamos solicitando el código. Por favor, espere un momento.',
      noReceivedCode: '¿No has recibido el código en tu teléfono?',
      noReceivedCode2: '¿No has recibido el código en el teléfono acabado en',
      otpCode: 'Código OTP (recibido por SMS)'
      },
      certificate: {
        mobileOnlyTitle: 'Uso exclusivo en ordenadores o portátiles',
        mobileOnlyLine1: 'Para garantizar la correcta finalización de este proceso, el acceso está habilitado únicamente desde',
        mobileOnlyDevices: 'ordenadores de sobremesa o portátiles.',
        mobileOnlyLine2: 'Actualmente, el servicio no es compatible con dispositivos móviles o tablets. Te recomendamos que vuelvas a iniciar el proceso desde un ordenador o portátil.',
        responsibleName: 'Nombre de la persona responsable',
        firstSurname: 'Primer apellido de la persona responsable',
        secondSurname: 'Segundo apellido de la persona responsable',
        idDocumentNumber: 'Número de documento de identificación',
        companyName: 'Razón social',
        dniPlaceholder: 'Ej: 12345678R',
        companyPlaceholder: 'Ej: Mi Empresa',
        cifPlaceholder: 'Ej: B12345678',
        idFrontUpload: 'Anverso documento de identificación (Max 2MB)',
        idBackUpload: 'Reverso documento de identificación (Max 2MB)',
        powerConsentBefore: 'Consiento expresamente a la activación de un poder digital según las condiciones que pueden verse ',
        powerConsentHere: 'aquí',
        requestAgainIn: 'Solicítalo de nuevo en',
        seconds: 'segundos',
        status: 'Estado',
        createNewRequest: 'Crear nueva solicitud',
        noAutofirmaHint: 'Si no tiene <strong>Autofirma</strong> instalado, antes de continuar, puedes instalarlo siguiendo este <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">link</a>.',
        password: {
          label: 'Contraseña',
          confirmLabel: 'Repite Contraseña',
          required: 'La contraseña es requerida',
          minLength: 'La contraseña debe tener al menos 8 carácteres',
          confirmRequired: 'Es necesario repetir la contraseña',
          mismatch: 'Las contraseñas deben coincidir',
          save: 'Guardar',
        },
        autofirma: {
          signedFileLoaded: 'Archivo firmado cargado',
          signCertificate: 'Firmar certificado',
          waitingAutofirma: 'Esperando autofirma...',
          noDocument: 'No hay documento para enviar.',
          prepareError: 'No se pudo preparar el documento: ',
          notFoundTitle: 'No se encuentra AutoFirma',
          notFoundMessage: 'No hemos detectado que Autofirma esté instalado en su equipo. Por favor utilice el siguiente enlace para descargarlo y vuelva a intentarlo.',
          timeoutMessage: 'No se ha recibido respuesta de AutoFirma. Compruebe que la aplicación está instalada y que el navegador puede abrirla, e inténtelo de nuevo. Si aún no la tiene, puede descargarla desde el siguiente enlace.',
          downloadAutofirma: 'Descargar Autofirma',
          cancel: 'Cancelar',
          unknownError: 'Error desconocido',
          errorOccurred: 'Ha ocurrido un error: ',
        },
        errors: {
          readServiceTerms: 'Debe leer los términos y condiciones del servicio',
          readCertTerms: 'Debe leer los términos y condiciones para la emisión de certificado',
          acceptServiceTerms: 'Debe aceptar los términos y condiciones del servicio',
          acceptSecurityPolicy: 'Debe aceptar la política de seguridad',
          acceptCertTerms: 'Debe aceptar los términos y condiciones para la emisión de certificado',
          acceptLegalCheck: 'Debe aceptar el check legal',
          consentPowerActivation: 'Debe consentir la activación de un poder digital registrado en el REA',
        },
        loadings: {
          gettingRequestInfo: 'Obteniendo información de la solicitud',
          uploadingDocs: 'Subiendo documentación...',
          sendingInfo: 'Enviando información..',
          startingEmission: 'Iniciando el proceso de emisión de certificado..',
          validatingInfo: 'Validando información, espere por favor..',
          sendingOtp: 'Enviando código OTP ..',
          processingRequest: 'Estamos procesando su solicitud. Espere un momento por favor',
        },
        requestRetry: {
          title: 'Error con la solicitud',
          description: 'Esta solicitud se encuentra en estado suspendida y ha sido reemplazada por otra mas reciente, si lo desea, puede continuar el flujo con esa solicitud haciendo click en el botón a continuación',
          continueFlow: 'Continuar flujo',
        },
      },
      flowCommon: {
        personType: 'Tipo de persona',
        natural: 'Natural',
        legal: 'Legal',
        name: 'Nombre',
        firstSurname: 'Primer apellido',
        secondSurname: 'Segundo apellido',
        emailPlaceholder: 'Ej: mi_email@dominio.com',
        phonePlaceholder: 'Ej: 123123123',
        dniPlaceholderShort: 'Ej: 2222221R',
        cifPlaceholderShort: 'Ej: 123123123',
        certTermsBefore: 'He leído y acepto los',
        certTermsLink: 'términos y condiciones',
        certTermsAfter: 'para la emisión del certificado',
        loadingData: 'Cargando datos..',
        sendingPassword: 'Enviando contraseña..',
      },
      videoid: {
        waitingVideoId: 'Aguardando validación por Video ID',
        redirectingVintegris: 'Redirigiendo a Vintegris, aguarde por favor...',
        sendingPassword: 'Enviando password..',
        sendingOtpShort: 'Enviando OTP..',
        invalidOtpRetry: 'El código introducido no es correcto. Por favor, inténtelo de nuevo',
      },
  },
  en: {
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI or NIE',
    birthday: 'Date of birth',
    expiration: 'ID expiration date',
    support: 'Support code',
    phone: 'Phone',
    email: 'Email',
    inputEmail: 'Enter your email',
    findExpiration: 'Where can I find it?',
    send: 'Send',
    unknownState: 'Unknown status',
    manual: 'Enter manually',

    warnings: {
      error: 'Error!',
      invalidDni: 'You must enter a valid DNI!',
      invalidNie: 'You must enter a valid NIE!',
      invalidNieOrDni: 'You must enter a valid DNI or NIE!',
      errorSomeData: 'Error in some data',
      noPinService: 'No Clave Pin service',
      noCirbeService: 'No Cirbe service',
      noCustomization: 'The widget customization has not been configured for this user',
      ocassionalError: 'We are detecting occasional errors; if you cannot complete your request, please try again later',
      wrongDni: 'Incorrect document number',
      wrongDniDesc: 'The entered document number is incorrect, please enter another one',
      wrongDate: 'Incorrect date',
      wrongDateDesc: 'The date is incorrect. Please check it',
      wrongSupport: 'Invalid support number!',
      inputSupport: 'Please enter the support code',
      unknownError: 'Unknown error: ',
      noSms: 'No SMS service',
      noSmsDesc: 'The user has no SMS service; we will try to access through the Clave PIN flow. Please fill in the required fields',
      noOtp: 'You have not received the OTP yet. Try again when you receive it',
      wrongOtp: 'Invalid code. Please enter the code received by SMS',
      haveToReadTerms: 'You must read the terms and conditions to continue',
      phoneError: 'Phone error',
      dontHavePhone: 'I don’t have another phone',
      badPhoneSS: 'The entered phone number does not match the one registered with Social Security, please enter another one',
      wrongBirthday: 'Incorrect date of birth',
      inputBirthDay: 'Please enter the date of birth',
      wrongExpiration: 'Incorrect expiration date',
      inputExpiration: 'Please enter the document expiration date',
      duplicatedRequest: 'Duplicate request!',
      alreadyHaveRequest: 'A request already exists for this client.',
      currentRequestStatus: 'Current request status: ',
      requestNoExist: 'The request does not exist',
      noRequests: 'There are no active requests with the required code',
      needMoreData: 'We need more data to validate access to public administrations',
    },
    abandoned: {
      afterWaitingOtpSS: 'Abandoned after waiting for Social Security OTP',
      afterInvalidOtpSS: 'Abandoned after invalid OTP in Social Security',
      afterInvalidOtpAEAT: 'Abandoned after invalid OTP in AEAT',
      afterWaitingOtpAEAT: 'Abandoned after waiting for AEAT OTP'
    },
    loadings: {
      gettingData: 'Retrieving request data...',
      resendingOtp: 'Resending OTP...',
      sendingData: 'Sending data...',
      validatingData: 'Validating new data, please wait...',
      validatingAndLoginSS: 'Validating data and logging into Social Security, please wait...',
      validatingAndLoginAEAT: 'Validating data and logging into AEAT, please wait...',
      resendingRequest: 'Retrying to submit the request...',
      smsToPin: 'An incorrect phone number was detected; we are going to try the Clave PIN flow',
      sendingNewPhone: 'Sending new phone number, please wait',
      validatingRequest: 'Validating request, please wait...',
      creatingRequest: 'Creating request, please wait',
      cancelingRequest: 'Cancelling request...',
      checkingSms: 'Checking SMS service...'
    },
    actions: {
      continue: 'Continue',
      cancel: 'Cancel process',
      back: 'Back',
      send: 'Send',
      retry: 'Try again',
      resend: 'Resend',
      next: 'Next',
      clickToFinish: 'Click here to finish',
      newRequest: 'New request',
      gotoCurrentRequest: 'Go to current request'
    },
    otp: {
      requestingOtp: 'We are requesting the code. Please wait a moment.',
      otpSentToNumber: 'The code has been sent to the phone ending in',
      requestingCode: 'We are requesting the code. Please wait a moment.',
      noReceivedCode: 'Didn’t receive the code on your phone?',
      noReceivedCode2: 'Didn’t receive the code on the phone ending in',
      otpCode: 'OTP code (received by SMS)'
    },
    certificate: {
      mobileOnlyTitle: 'Desktop or laptop use only',
      mobileOnlyLine1: 'To ensure this process completes correctly, access is enabled only from',
      mobileOnlyDevices: 'desktop or laptop computers.',
      mobileOnlyLine2: 'This service is not currently compatible with mobile devices or tablets. Please restart the process from a desktop or laptop.',
      responsibleName: 'Name of the responsible person',
      firstSurname: 'First surname of the responsible person',
      secondSurname: 'Second surname of the responsible person',
      idDocumentNumber: 'Identification document number',
      companyName: 'Company name',
      dniPlaceholder: 'E.g.: 12345678R',
      companyPlaceholder: 'E.g.: My Company',
      cifPlaceholder: 'E.g.: B12345678',
      idFrontUpload: 'Front of identification document (Max 2MB)',
      idBackUpload: 'Back of identification document (Max 2MB)',
      powerConsentBefore: 'I expressly consent to the activation of a digital power according to the conditions that can be viewed ',
      powerConsentHere: 'here',
      requestAgainIn: 'Request it again in',
      seconds: 'seconds',
      status: 'Status',
      createNewRequest: 'Create new request',
      noAutofirmaHint: 'If you do not have <strong>Autofirma</strong> installed, before continuing you can install it by following this <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">link</a>.',
      password: {
        label: 'Password',
        confirmLabel: 'Repeat password',
        required: 'Password is required',
        minLength: 'Password must be at least 8 characters',
        confirmRequired: 'You must repeat the password',
        mismatch: 'Passwords must match',
        save: 'Save',
      },
      autofirma: {
        signedFileLoaded: 'Signed file uploaded',
        signCertificate: 'Sign certificate',
        waitingAutofirma: 'Waiting for Autofirma...',
        noDocument: 'There is no document to send.',
        prepareError: 'Could not prepare the document: ',
        notFoundTitle: 'Autofirma not found',
        notFoundMessage: 'We have not detected Autofirma installed on your device. Please use the following link to download it and try again.',
        timeoutMessage: 'No response was received from Autofirma. Check that the application is installed and that the browser can open it, then try again. If you do not have it yet, you can download it from the following link.',
        downloadAutofirma: 'Download Autofirma',
        cancel: 'Cancel',
        unknownError: 'Unknown error',
        errorOccurred: 'An error occurred: ',
      },
      errors: {
        readServiceTerms: 'You must read the service terms and conditions',
        readCertTerms: 'You must read the terms and conditions for certificate issuance',
        acceptServiceTerms: 'You must accept the service terms and conditions',
        acceptSecurityPolicy: 'You must accept the security policy',
        acceptCertTerms: 'You must accept the terms and conditions for certificate issuance',
        acceptLegalCheck: 'You must accept the legal checkbox',
        consentPowerActivation: 'You must consent to the activation of a digital power registered in the REA',
      },
        loadings: {
          gettingRequestInfo: 'Retrieving request information',
          uploadingDocs: 'Uploading documentation...',
          sendingInfo: 'Sending information...',
          startingEmission: 'Starting certificate issuance process...',
          validatingInfo: 'Validating information, please wait...',
          sendingOtp: 'Sending OTP code...',
          processingRequest: 'We are processing your request. Please wait a moment',
        },
        requestRetry: {
          title: 'Request error',
          description: 'This request is suspended and has been replaced by a more recent one. If you wish, you can continue the flow with that request by clicking the button below',
          continueFlow: 'Continue flow',
        },
    },
    flowCommon: {
      personType: 'Person type',
      natural: 'Natural',
      legal: 'Legal',
      name: 'First name',
      firstSurname: 'First surname',
      secondSurname: 'Second surname',
      emailPlaceholder: 'E.g.: my_email@domain.com',
      phonePlaceholder: 'E.g.: 123123123',
      dniPlaceholderShort: 'E.g.: 2222221R',
      cifPlaceholderShort: 'E.g.: 123123123',
      certTermsBefore: 'I have read and accept the',
      certTermsLink: 'terms and conditions',
      certTermsAfter: 'for certificate issuance',
      loadingData: 'Loading data...',
      sendingPassword: 'Sending password...',
    },
    videoid: {
      waitingVideoId: 'Waiting for Video ID validation',
      redirectingVintegris: 'Redirecting to Vintegris, please wait...',
      sendingPassword: 'Sending password...',
      sendingOtpShort: 'Sending OTP...',
      invalidOtpRetry: 'The entered code is incorrect. Please try again',
    },
  },
  ca: {
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI o NIE',
    birthday: 'Data de naixement',
    expiration: 'Data de caducitat del DNI',
    support: 'Codi de suport',
    phone: 'Telèfon',
    email: 'Correu electrònic',
    inputEmail: 'Introdueix el teu correu electrònic',
    findExpiration: 'On la trobo?',
    send: 'Enviar',
    unknownState: 'Estat desconegut',
    manual: 'Introduir manualment',

    warnings: {
      error: 'Error!',
      invalidDni: 'Has d\'introduir un DNI vàlid!',
      invalidNie: 'Has d\'introduir un NIE vàlid!',
      invalidNieOrDni: 'Has d\'introduir un DNI o NIE vàlid!',
      errorSomeData: 'Error en algunes dades',
      noPinService: 'Sense servei Clave PIN',
      noCirbeService: 'Sin servicio Cirbe',
      noCustomization: 'No s\'ha configurat la personalització del widget per a aquest usuari',
      ocassionalError: 'Estem detectant errors ocasionals; si no pots completar la teva sol·licitud, torna-ho a intentar més tard',
      wrongDni: 'Número de document incorrecte',
      wrongDniDesc: 'El número de document introduït és incorrecte, si us plau, introdueix-ne un altre',
      wrongDate: 'Data incorrecta',
      wrongDateDesc: 'La data és incorrecta. Revisa-la, si us plau',
      wrongSupport: 'Número de suport no vàlid!',
      inputSupport: 'Si us plau, introdueix el codi de suport',
      unknownError: 'Error desconegut: ',
      noSms: 'Sense servei SMS',
      noSmsDesc: 'L\'usuari no té servei d\'SMS; intentarem accedir pel flux Clave PIN. Si us plau, omple els camps necessaris',
      noOtp: 'Encara no has rebut l’OTP. Torna-ho a intentar quan el rebis',
      wrongOtp: 'Codi no vàlid. Si us plau, introdueix el codi rebut per SMS',
      haveToReadTerms: 'Has de llegir els termes i condicions per poder continuar',
      phoneError: 'Error amb el telèfon',
      dontHavePhone: 'No tinc un altre telèfon',
      badPhoneSS: 'El telèfon introduït no coincideix amb el registrat a la Seguretat Social, si us plau, introdueix-ne un altre',
      wrongBirthday: 'Data de naixement incorrecta',
      inputBirthDay: 'Si us plau, introdueix la data de naixement',
      wrongExpiration: 'Data de caducitat incorrecta',
      inputExpiration: 'Si us plau, introdueix la data de caducitat del document',
      duplicatedRequest: 'Sol·licitud duplicada!',
      alreadyHaveRequest: 'Ja existeix una sol·licitud per a aquest client.',
      currentRequestStatus: 'Estat de la sol·licitud actual: ',
      requestNoExist: 'La sol·licitud no existeix',
      noRequests: 'No hi ha sol·licituds actives amb el codi requerit',
      needMoreData: 'Necessitem més dades per validar l’accés a les administracions públiques',
    },
    abandoned: {
      afterWaitingOtpSS: 'Abandonat després d’esperar l’OTP de la Seguretat Social',
      afterInvalidOtpSS: 'Abandonat després d’un OTP no vàlid a la Seguretat Social',
      afterInvalidOtpAEAT: 'Abandonat després d’un OTP no vàlid a l’AEAT',
      afterWaitingOtpAEAT: 'Abandonat després d’esperar l’OTP de l’AEAT'
    },
    loadings: {
      gettingData: 'Obtenint dades de la sol·licitud...',
      resendingOtp: 'Reenviant l’OTP...',
      sendingData: 'Enviant dades...',
      validatingData: 'Validant dades noves, espera, si us plau...',
      validatingAndLoginSS: 'Validant dades i iniciant sessió a la Seguretat Social, espera, si us plau...',
      validatingAndLoginAEAT: 'Validant dades i iniciant sessió a l’AEAT, espera, si us plau...',
      resendingRequest: 'Tornant a intentar enviar la sol·licitud...',
      smsToPin: 'S’ha detectat un número de telèfon incorrecte; provarem el flux Clave PIN',
      sendingNewPhone: 'Enviant el nou telèfon, espera, si us plau',
      validatingRequest: 'Validant la sol·licitud, espera, si us plau...',
      creatingRequest: 'Creant la sol·licitud, espera',
      cancelingRequest: 'Cancel·lant la sol·licitud...',
      checkingSms: 'Verificant el servei SMS...'
    },
    actions: {
      continue: 'Continuar',
      cancel: 'Cancel·lar el procés',
      back: 'Tornar',
      send: 'Enviar',
      retry: 'Torna-ho a intentar',
      resend: 'Reenviar',
      next: 'Següent',
      clickToFinish: 'Fes clic aquí per finalitzar',
      newRequest: 'Nova sol·licitud',
      gotoCurrentRequest: 'Anar a la sol·licitud actual'
    },
    otp: {
      requestingOtp: 'Estem sol·licitant el codi. Si us plau, espera un moment.',
      otpSentToNumber: 'El codi s’ha enviat al telèfon acabat en',
      requestingCode: 'Estem sol·licitant el codi. Si us plau, espera un moment.',
      noReceivedCode: 'No has rebut el codi al teu telèfon?',
      noReceivedCode2: 'No has rebut el codi al telèfon acabat en',
      otpCode: 'Codi OTP (rebut per SMS)'
    },
    certificate: {
      mobileOnlyTitle: 'Ús exclusiu en ordinadors o portàtils',
      mobileOnlyLine1: 'Per garantir la correcta finalització d\'aquest procés, l\'accés està habilitat únicament des de',
      mobileOnlyDevices: 'ordinadors d\'escriptori o portàtils.',
      mobileOnlyLine2: 'Actualment, el servei no és compatible amb dispositius mòbils o tauletes. Et recomanem que tornis a iniciar el procés des d\'un ordinador o portàtil.',
      responsibleName: 'Nom de la persona responsable',
      firstSurname: 'Primer cognom de la persona responsable',
      secondSurname: 'Segon cognom de la persona responsable',
      idDocumentNumber: 'Número de document d\'identificació',
      companyName: 'Raó social',
      dniPlaceholder: 'Ex: 12345678R',
      companyPlaceholder: 'Ex: La meva empresa',
      cifPlaceholder: 'Ex: B12345678',
      idFrontUpload: 'Anvers del document d\'identificació (màx. 2 MB)',
      idBackUpload: 'Revers del document d\'identificació (màx. 2 MB)',
      powerConsentBefore: 'Consenteixo expressament l\'activació d\'un poder digital segons les condicions que es poden consultar ',
      powerConsentHere: 'aquí',
      requestAgainIn: 'Sol·licita-ho de nou en',
      seconds: 'segons',
      status: 'Estat',
      createNewRequest: 'Crear nova sol·licitud',
      noAutofirmaHint: 'Si no tens <strong>Autofirma</strong> instal·lat, abans de continuar pots instal·lar-lo seguint aquest <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">enllaç</a>.',
      password: {
        label: 'Contrasenya',
        confirmLabel: 'Repeteix la contrasenya',
        required: 'La contrasenya és obligatòria',
        minLength: 'La contrasenya ha de tenir almenys 8 caràcters',
        confirmRequired: 'Cal repetir la contrasenya',
        mismatch: 'Les contrasenyes han de coincidir',
        save: 'Desar',
      },
      autofirma: {
        signedFileLoaded: 'Fitxer signat carregat',
        signCertificate: 'Signar certificat',
        waitingAutofirma: 'Esperant Autofirma...',
        noDocument: 'No hi ha cap document per enviar.',
        prepareError: 'No s\'ha pogut preparar el document: ',
        notFoundTitle: 'No s\'ha trobat Autofirma',
        notFoundMessage: 'No hem detectat Autofirma instal·lat al teu equip. Si us plau, utilitza l\'enllaç següent per descarregar-lo i torna-ho a intentar.',
        timeoutMessage: 'No s\'ha rebut resposta d\'Autofirma. Comprova que l\'aplicació està instal·lada i que el navegador pot obrir-la, i torna-ho a intentar. Si encara no la tens, pots descarregar-la des de l\'enllaç següent.',
        downloadAutofirma: 'Descarregar Autofirma',
        cancel: 'Cancel·lar',
        unknownError: 'Error desconegut',
        errorOccurred: 'S\'ha produït un error: ',
      },
      errors: {
        readServiceTerms: 'Has de llegir els termes i condicions del servei',
        readCertTerms: 'Has de llegir els termes i condicions per a l\'emissió del certificat',
        acceptServiceTerms: 'Has d\'acceptar els termes i condicions del servei',
        acceptSecurityPolicy: 'Has d\'acceptar la política de seguretat',
        acceptCertTerms: 'Has d\'acceptar els termes i condicions per a l\'emissió del certificat',
        acceptLegalCheck: 'Has d\'acceptar el check legal',
        consentPowerActivation: 'Has de consentir l\'activació d\'un poder digital registrat al REA',
      },
      loadings: {
        gettingRequestInfo: 'Obtenint informació de la sol·licitud',
        uploadingDocs: 'Pujant documentació...',
        sendingInfo: 'Enviant informació...',
        startingEmission: 'Iniciant el procés d\'emissió del certificat...',
        validatingInfo: 'Validant informació, espera, si us plau...',
        sendingOtp: 'Enviant codi OTP...',
        processingRequest: 'Estem processant la teva sol·licitud. Espera un moment, si us plau',
      },
      requestRetry: {
        title: 'Error amb la sol·licitud',
        description: 'Aquesta sol·licitud està suspesa i ha estat substituïda per una de més recent. Si ho desitges, pots continuar el flux amb aquesta sol·licitud fent clic al botó següent',
        continueFlow: 'Continuar flux',
      },
    },
    flowCommon: {
      personType: 'Tipus de persona',
      natural: 'Natural',
      legal: 'Jurídica',
      name: 'Nom',
      firstSurname: 'Primer cognom',
      secondSurname: 'Segon cognom',
      emailPlaceholder: 'Ex: el_meu_correu@domini.com',
      phonePlaceholder: 'Ex: 123123123',
      dniPlaceholderShort: 'Ex: 2222221R',
      cifPlaceholderShort: 'Ex: 123123123',
      certTermsBefore: 'He llegit i accepto els',
      certTermsLink: 'termes i condicions',
      certTermsAfter: 'per a l\'emissió del certificat',
      loadingData: 'Carregant dades...',
      sendingPassword: 'Enviant contrasenya...',
    },
    videoid: {
      waitingVideoId: 'Esperant validació per Video ID',
      redirectingVintegris: 'Redirigint a Vintegris, espera, si us plau...',
      sendingPassword: 'Enviant contrasenya...',
      sendingOtpShort: 'Enviant OTP...',
      invalidOtpRetry: 'El codi introduït no és correcte. Si us plau, torna-ho a intentar',
    },
  },
  fr: {
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI ou NIE',
    birthday: 'Date de naissance',
    expiration: "Date d'expiration du DNI",
    support: 'Code de support',
    phone: 'Téléphone',
    email: 'E-mail',
    inputEmail: 'Saisis ton e-mail',
    findExpiration: 'Où la trouver ?',
    send: 'Envoyer',
    unknownState: 'Statut inconnu',
    manual: 'Saisir manuellement',

    warnings: {
      error: 'Erreur !',
      invalidDni: 'Tu dois saisir un DNI valide !',
      invalidNie: 'Tu dois saisir un NIE valide !',
      invalidNieOrDni: 'Tu dois saisir un DNI ou NIE valide !',
      errorSomeData: 'Erreur dans certaines données',
      noPinService: 'Sans service Clave PIN',
      noCirbeService: 'Sans service Cirbe',
      noCustomization: "La personnalisation du widget n'a pas été configurée pour cet utilisateur",
      ocassionalError: 'Nous détectons des erreurs occasionnelles ; si tu ne peux pas compléter ta demande, réessaie plus tard',
      wrongDni: 'Numéro de document incorrect',
      wrongDniDesc: 'Le numéro de document saisi est incorrect, merci d’en saisir un autre',
      wrongDate: 'Date incorrecte',
      wrongDateDesc: 'La date est incorrecte. Vérifie-la, s’il te plaît',
      wrongSupport: 'Numéro de support invalide !',
      inputSupport: 'Merci de saisir le code de support',
      unknownError: 'Erreur inconnue : ',
      noSms: 'Sans service SMS',
      noSmsDesc: "L'utilisateur n'a pas de service SMS ; nous allons tenter d'accéder via le flux Clave PIN, merci de remplir les champs requis",
      noOtp: "Tu n'as pas encore reçu l'OTP. Réessaie quand tu l'auras reçu",
      wrongOtp: 'Code invalide. Merci de saisir le code reçu par SMS',
      haveToReadTerms: 'Tu dois lire les termes et conditions pour pouvoir continuer',
      phoneError: 'Erreur avec le téléphone',
      dontHavePhone: "Je n'ai pas d'autre téléphone",
      badPhoneSS: "Le numéro de téléphone saisi ne correspond pas à celui enregistré à la Sécurité sociale, merci d'en saisir un autre",
      wrongBirthday: 'Date de naissance incorrecte',
      inputBirthDay: 'Merci de saisir la date de naissance',
      wrongExpiration: "Date d'expiration incorrecte",
      inputExpiration: "Merci de saisir la date d'expiration du document",
      duplicatedRequest: 'Demande dupliquée !',
      alreadyHaveRequest: 'Il existe déjà une demande pour ce client.',
      currentRequestStatus: 'Statut actuel de la demande : ',
      requestNoExist: "La demande n'existe pas",
      noRequests: "Il n'y a pas de demandes actives avec le code requis",
      needMoreData: "Nous avons besoin de plus de données pour valider l'accès aux administrations publiques",
    },
    abandoned: {
      afterWaitingOtpSS: "Abandonné après avoir attendu l'OTP de la Sécurité sociale",
      afterInvalidOtpSS: "Abandonné après un OTP invalide à la Sécurité sociale",
      afterInvalidOtpAEAT: "Abandonné après un OTP invalide à l'AEAT",
      afterWaitingOtpAEAT: "Abandonné après avoir attendu l'OTP de l'AEAT"
    },
    loadings: {
      gettingData: 'Récupération des données de la demande...',
      resendingOtp: "Renvoi de l'OTP...",
      sendingData: 'Envoi des données...',
      validatingData: 'Validation des nouvelles données, merci de patienter...',
      validatingAndLoginSS: 'Validation des données et connexion à la Sécurité sociale, merci de patienter...',
      validatingAndLoginAEAT: "Validation des données et connexion à l'AEAT, merci de patienter...",
      resendingRequest: "Nouvelle tentative d'envoi de la demande...",
      smsToPin: 'Un numéro de téléphone incorrect a été détecté ; nous allons essayer le flux Clave PIN',
      sendingNewPhone: 'Envoi du nouveau numéro de téléphone, merci de patienter',
      validatingRequest: 'Validation de la demande, merci de patienter...',
      creatingRequest: 'Création de la demande, merci de patienter',
      cancelingRequest: 'Annulation de la demande...',
      checkingSms: 'Vérification du service SMS...'
    },
    actions: {
      continue: 'Continuer',
      cancel: 'Annuler le processus',
      back: 'Retour',
      send: 'Envoyer',
      retry: 'Réessayer',
      resend: 'Renvoyer',
      next: 'Suivant',
      clickToFinish: 'Clique ici pour terminer',
      newRequest: 'Nouvelle demande',
      gotoCurrentRequest: 'Aller à la demande actuelle'
    },
    otp: {
      requestingOtp: 'Nous demandons le code. Merci de patienter un instant.',
      otpSentToNumber: 'Le code a été envoyé au téléphone se terminant par',
      requestingCode: 'Nous demandons le code. Merci de patienter un instant.',
      noReceivedCode: "Tu n'as pas reçu le code sur ton téléphone ?",
      noReceivedCode2: "Tu n'as pas reçu le code sur le téléphone se terminant par",
      otpCode: 'Code OTP (reçu par SMS)'
    }
  },
  it: {
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI o NIE',
    birthday: 'Data di nascita',
    expiration: 'Data di scadenza del DNI',
    support: 'Codice di supporto',
    phone: 'Telefono',
    email: 'Email',
    inputEmail: 'Inserisci la tua email',
    findExpiration: 'Dove la trovo?',
    send: 'Invia',
    unknownState: 'Stato sconosciuto',
    manual: 'Inserisci manualmente',

    warnings: {
      error: 'Errore!',
      invalidDni: 'Devi inserire un DNI valido!',
      invalidNie: 'Devi inserire un NIE valido!',
      invalidNieOrDni: 'Devi inserire un DNI o NIE valido!',
      errorSomeData: 'Errore in alcuni dati',
      noPinService: 'Servizio Clave PIN non disponibile',
      noCirbeService: 'Servizio Cirbe non disponibile',
      noCustomization: 'La personalizzazione del widget non è stata configurata per questo utente',
      ocassionalError: 'Stiamo rilevando errori occasionali, se non riesci a completare la tua richiesta, riprova più tardi',
      wrongDni: 'Numero di documento errato',
      wrongDniDesc: 'Il numero di documento inserito è errato, inseriscine un altro per favore',
      wrongDate: 'Data errata',
      wrongDateDesc: 'La data è errata. Per favore, controllala',
      wrongSupport: 'Codice di supporto non valido!',
      inputSupport: 'Per favore, inserisci il codice di supporto',
      unknownError: 'Errore sconosciuto: ',
      noSms: 'Servizio SMS non disponibile',
      noSmsDesc: 'L\'utente non ha il servizio SMS, proveremo ad accedere tramite il flusso Clave PIN, per favore compila i campi necessari',
      noOtp: 'Non hai ancora ricevuto l\'OTP. Riprova quando lo ricevi',
      wrongOtp: 'Codice non valido. Per favore, inserisci il codice ricevuto via SMS',
      haveToReadTerms: 'Devi leggere i termini e le condizioni per poter continuare',
      phoneError: 'Errore con il telefono',
      dontHavePhone: 'Non ho un altro telefono',
      badPhoneSS: 'Il telefono inserito non corrisponde a quello registrato presso la Sicurezza Sociale, inseriscine un altro per favore',
      wrongBirthday: 'Data di nascita errata',
      inputBirthDay: 'Per favore, inserisci la data di nascita',
      wrongExpiration: 'Data di scadenza errata',
      inputExpiration: 'Per favore, inserisci la data di scadenza del documento',
      duplicatedRequest: 'Richiesta duplicata!',
      alreadyHaveRequest: 'Esiste già una richiesta per questo cliente.',
      currentRequestStatus: 'Stato della richiesta attuale: ',
      requestNoExist: 'La richiesta non esiste',
      noRequests: 'Non esistono richieste attive con il codice richiesto',
      needMoreData: 'Abbiamo bisogno di più dati per convalidare l\'accesso alle amministrazioni pubbliche',
    },
    abandoned: {
      afterWaitingOtpSS: 'Abbandonato dopo aver atteso l\'OTP della Sicurezza Sociale',
      afterInvalidOtpSS: 'Abbandonato dopo OTP non valido nella Sicurezza Sociale',
      afterInvalidOtpAEAT: 'Abbandonato dopo OTP non valido nell\'AEAT',
      afterWaitingOtpAEAT: 'Abbandonato dopo aver atteso l\'OTP dell\'AEAT',
    },
    loadings: {
      gettingData: 'Recupero dei dati della richiesta...',
      resendingOtp: 'Invio nuovamente l\'OTP...',
      sendingData: 'Invio dei dati...',
      validatingData: 'Validazione dei nuovi dati, attendere per favore...',
      validatingAndLoginSS: 'Validazione dei dati e accesso alla Sicurezza Sociale, attendere per favore...',
      validatingAndLoginAEAT: 'Validazione dei dati e accesso all\'AEAT, attendere per favore...',
      resendingRequest: 'Nuovo tentativo di invio della richiesta...',
      smsToPin: 'È stato rilevato un numero di telefono errato, proveremo tramite il flusso Clave PIN',
      sendingNewPhone: 'Invio del nuovo telefono, attendere per favore',
      validatingRequest: 'Validazione della richiesta, attendere per favore...',
      creatingRequest: 'Creazione della richiesta, attendere per favore',
      cancelingRequest: 'Annullamento della richiesta...',
      checkingSms: 'Verifica del servizio SMS...',
    },
    actions: {
      continue: 'Continua',
      cancel: 'Annulla processo',
      back: 'Indietro',
      send: 'Invia',
      retry: 'Riprova',
      resend: 'Reinvia',
      next: 'Avanti',
      clickToFinish: 'Clicca qui per terminare',
      newRequest: 'Nuova richiesta',
      gotoCurrentRequest: 'Vai alla richiesta attuale',
    },
    otp: {
      requestingOtp: 'Stiamo richiedendo il codice. Attendere un momento, per favore.',
      otpSentToNumber: 'Il codice è stato inviato al telefono che termina con',
      requestingCode: 'Stiamo richiedendo il codice. Attendere un momento, per favore.',
      noReceivedCode: 'Non hai ricevuto il codice sul tuo telefono?',
      noReceivedCode2: 'Non hai ricevuto il codice sul telefono che termina con',
      otpCode: 'Codice OTP (ricevuto via SMS)',
    },
  },
  pt: {
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI ou NIE',
    birthday: 'Data de nascimento',
    expiration: 'Data de validade do DNI',
    support: 'Código de suporte',
    phone: 'Telefone',
    email: 'E-mail',
    inputEmail: 'Digite seu e-mail',
    findExpiration: 'Onde encontro?',
    send: 'Enviar',
    unknownState: 'Estado desconhecido',
    manual: 'Inserir manualmente',

    warnings: {
      error: 'Erro!',
      invalidDni: 'Você deve inserir um DNI válido!',
      invalidNie: 'Você deve inserir um NIE válido!',
      invalidNieOrDni: 'Você deve inserir um DNI ou NIE válido!',
      errorSomeData: 'Erro em alguns dados',
      noPinService: 'Sem serviço Clave PIN',
      noCirbeService: 'Sem serviço Cirbe',
      noCustomization: 'A personalização do widget não foi configurada para este usuário',
      ocassionalError: 'Estamos detectando erros ocasionais; se não conseguir concluir sua solicitação, tente novamente mais tarde',
      wrongDni: 'Número de documento incorreto',
      wrongDniDesc: 'O número de documento informado está incorreto, insira outro por favor',
      wrongDate: 'Data incorreta',
      wrongDateDesc: 'A data está incorreta. Verifique, por favor',
      wrongSupport: 'Código de suporte inválido!',
      inputSupport: 'Por favor, insira o código de suporte',
      unknownError: 'Erro desconhecido: ',
      noSms: 'Sem serviço SMS',
      noSmsDesc: 'O usuário não possui serviço de SMS; vamos tentar entrar pelo fluxo Clave PIN, por favor preencha os campos necessários',
      noOtp: 'Você ainda não recebeu o OTP. Tente novamente quando recebê-lo',
      wrongOtp: 'Código inválido. Por favor, insira o código recebido por SMS',
      haveToReadTerms: 'Você deve ler os termos e condições para continuar',
      phoneError: 'Erro com o telefone',
      dontHavePhone: 'Não tenho outro telefone',
      badPhoneSS: 'O telefone informado não coincide com o registrado na Seguridade Social, por favor insira outro',
      wrongBirthday: 'Data de nascimento incorreta',
      inputBirthDay: 'Por favor, insira a data de nascimento',
      wrongExpiration: 'Data de validade incorreta',
      inputExpiration: 'Por favor, insira a data de validade do documento',
      duplicatedRequest: 'Solicitação duplicada!',
      alreadyHaveRequest: 'Já existe uma solicitação para este cliente.',
      currentRequestStatus: 'Status da solicitação atual: ',
      requestNoExist: 'A solicitação não existe',
      noRequests: 'Não existem solicitações ativas com o código informado',
      needMoreData: 'Precisamos de mais dados para validar o acesso às administrações públicas',
    },
    abandoned: {
      afterWaitingOtpSS: 'Abandonado após aguardar o OTP da Seguridade Social',
      afterInvalidOtpSS: 'Abandonado após OTP inválido na Seguridade Social',
      afterInvalidOtpAEAT: 'Abandonado após OTP inválido na AEAT',
      afterWaitingOtpAEAT: 'Abandonado após aguardar o OTP da AEAT',
    },
    loadings: {
      gettingData: 'Obtendo dados da solicitação...',
      resendingOtp: 'Reenviando OTP...',
      sendingData: 'Enviando dados...',
      validatingData: 'Validando novos dados, aguarde por favor...',
      validatingAndLoginSS: 'Validando dados e acessando a Seguridade Social, aguarde por favor...',
      validatingAndLoginAEAT: 'Validando dados e acessando a AEAT, aguarde por favor...',
      resendingRequest: 'Tentando reenviar a solicitação...',
      smsToPin: 'Detectamos um número de telefone incorreto, vamos tentar pelo fluxo Clave PIN',
      sendingNewPhone: 'Enviando novo telefone, aguarde por favor',
      validatingRequest: 'Validando solicitação, aguarde por favor...',
      creatingRequest: 'Criando solicitação, aguarde por favor',
      cancelingRequest: 'Cancelando solicitação...',
      checkingSms: 'Verificando serviço SMS...',
    },
    actions: {
      continue: 'Continuar',
      cancel: 'Cancelar processo',
      back: 'Voltar',
      send: 'Enviar',
      retry: 'Tentar novamente',
      resend: 'Reenviar',
      next: 'Seguinte',
      clickToFinish: 'Clique aqui para finalizar',
      newRequest: 'Nova solicitação',
      gotoCurrentRequest: 'Ir para a solicitação atual',
    },
    otp: {
      requestingOtp: 'Estamos solicitando o código. Por favor, aguarde um momento.',
      otpSentToNumber: 'O código foi enviado para o telefone terminado em',
      requestingCode: 'Estamos solicitando o código. Por favor, aguarde um momento.',
      noReceivedCode: 'Não recebeu o código no seu telefone?',
      noReceivedCode2: 'Não recebeu o código no telefone terminado em',
      otpCode: 'Código OTP (recebido por SMS)',
    },
    certificate: {
      mobileOnlyTitle: 'Uso exclusivo em computadores ou portáteis',
      mobileOnlyLine1: 'Para garantir a conclusão correta deste processo, o acesso está habilitado apenas em',
      mobileOnlyDevices: 'computadores de mesa ou portáteis.',
      mobileOnlyLine2: 'Atualmente, o serviço não é compatível com dispositivos móveis ou tablets. Recomendamos que reinicie o processo a partir de um computador ou portátil.',
      responsibleName: 'Nome da pessoa responsável',
      firstSurname: 'Primeiro apelido da pessoa responsável',
      secondSurname: 'Segundo apelido da pessoa responsável',
      idDocumentNumber: 'Número do documento de identificação',
      companyName: 'Razão social',
      dniPlaceholder: 'Ex.: 12345678R',
      companyPlaceholder: 'Ex.: A minha empresa',
      cifPlaceholder: 'Ex.: B12345678',
      idFrontUpload: 'Frente do documento de identificação (máx. 2 MB)',
      idBackUpload: 'Verso do documento de identificação (máx. 2 MB)',
      powerConsentBefore: 'Consinto expressamente a ativação de um poder digital de acordo com as condições que podem ser consultadas ',
      powerConsentHere: 'aqui',
      requestAgainIn: 'Solicite novamente em',
      seconds: 'segundos',
      status: 'Estado',
      createNewRequest: 'Criar nova solicitação',
      noAutofirmaHint: 'Se não tem o <strong>Autofirma</strong> instalado, antes de continuar pode instalá-lo seguindo este <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">link</a>.',
      password: {
        label: 'Palavra-passe',
        confirmLabel: 'Repetir palavra-passe',
        required: 'A palavra-passe é obrigatória',
        minLength: 'A palavra-passe deve ter pelo menos 8 caracteres',
        confirmRequired: 'É necessário repetir a palavra-passe',
        mismatch: 'As palavras-passe devem coincidir',
        save: 'Guardar',
      },
      autofirma: {
        signedFileLoaded: 'Ficheiro assinado carregado',
        signCertificate: 'Assinar certificado',
        waitingAutofirma: 'A aguardar Autofirma...',
        noDocument: 'Não há documento para enviar.',
        prepareError: 'Não foi possível preparar o documento: ',
        notFoundTitle: 'Autofirma não encontrado',
        notFoundMessage: 'Não detetámos o Autofirma instalado no seu equipamento. Utilize o seguinte link para descarregá-lo e tente novamente.',
        timeoutMessage: 'Não foi recebida resposta do Autofirma. Verifique se a aplicação está instalada e se o navegador a pode abrir, e tente novamente. Se ainda não a tiver, pode descarregá-la no link seguinte.',
        downloadAutofirma: 'Descarregar Autofirma',
        cancel: 'Cancelar',
        unknownError: 'Erro desconhecido',
        errorOccurred: 'Ocorreu um erro: ',
      },
      errors: {
        readServiceTerms: 'Deve ler os termos e condições do serviço',
        readCertTerms: 'Deve ler os termos e condições para a emissão do certificado',
        acceptServiceTerms: 'Deve aceitar os termos e condições do serviço',
        acceptSecurityPolicy: 'Deve aceitar a política de segurança',
        acceptCertTerms: 'Deve aceitar os termos e condições para a emissão do certificado',
        acceptLegalCheck: 'Deve aceitar o check legal',
        consentPowerActivation: 'Deve consentir a ativação de um poder digital registado no REA',
      },
      loadings: {
        gettingRequestInfo: 'A obter informação da solicitação',
        uploadingDocs: 'A carregar documentação...',
        sendingInfo: 'A enviar informação...',
        startingEmission: 'A iniciar o processo de emissão do certificado...',
        validatingInfo: 'A validar informação, aguarde por favor...',
        sendingOtp: 'A enviar código OTP...',
        processingRequest: 'Estamos a processar a sua solicitação. Aguarde um momento, por favor',
      },
      requestRetry: {
        title: 'Erro na solicitação',
        description: 'Esta solicitação está suspensa e foi substituída por outra mais recente. Se desejar, pode continuar o fluxo com essa solicitação clicando no botão abaixo',
        continueFlow: 'Continuar fluxo',
      },
    },
    flowCommon: {
      personType: 'Tipo de pessoa',
      natural: 'Natural',
      legal: 'Jurídica',
      name: 'Nome',
      firstSurname: 'Primeiro apelido',
      secondSurname: 'Segundo apelido',
      emailPlaceholder: 'Ex.: o_meu_email@dominio.com',
      phonePlaceholder: 'Ex.: 123123123',
      dniPlaceholderShort: 'Ex.: 2222221R',
      cifPlaceholderShort: 'Ex.: 123123123',
      certTermsBefore: 'Li e aceito os',
      certTermsLink: 'termos e condições',
      certTermsAfter: 'para a emissão do certificado',
      loadingData: 'A carregar dados...',
      sendingPassword: 'A enviar palavra-passe...',
    },
    videoid: {
      waitingVideoId: 'A aguardar validação por Video ID',
      redirectingVintegris: 'A redirecionar para Vintegris, aguarde por favor...',
      sendingPassword: 'A enviar palavra-passe...',
      sendingOtpShort: 'A enviar OTP...',
      invalidOtpRetry: 'O código introduzido não está correto. Por favor, tente novamente',
    },
  },
  de: {
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI oder NIE',
    birthday: 'Geburtsdatum',
    expiration: 'Ablaufdatum des DNI',
    support: 'Support-Code',
    phone: 'Telefon',
    email: 'E-Mail',
    inputEmail: 'Gib deine E-Mail ein',
    findExpiration: 'Wo finde ich ihn?',
    send: 'Senden',
    unknownState: 'Unbekannter Status',
    manual: 'Manuell eingeben',

    warnings: {
      error: 'Fehler!',
      invalidDni: 'Du musst eine gültige DNI eingeben!',
      invalidNie: 'Du musst eine gültige NIE eingeben!',
      invalidNieOrDni: 'Du musst eine gültige DNI oder NIE eingeben!',
      errorSomeData: 'Fehler in einigen Angaben',
      noPinService: 'Kein Clave-PIN-Dienst',
      noCirbeService: 'Kein Cirbe-Dienst',
      noCustomization: 'Das Widget wurde für diesen Benutzer nicht konfiguriert',
      ocassionalError: 'Wir stellen gelegentliche Fehler fest. Wenn du deine Anfrage nicht abschließen kannst, versuche es später erneut',
      wrongDni: 'Dokumentennummer falsch',
      wrongDniDesc: 'Die eingegebene Dokumentennummer ist falsch, bitte gib eine andere ein',
      wrongDate: 'Datum falsch',
      wrongDateDesc: 'Das Geburtsdatum ist falsch. Bitte überprüfe es',
      wrongSupport: 'Support-Code ungültig!',
      inputSupport: 'Bitte gib den Support-Code ein',
      unknownError: 'Unbekannter Fehler: ',
      noSms: 'Kein SMS-Dienst',
      noSmsDesc: 'Der Benutzer hat keinen SMS-Dienst. Wir versuchen es über den Clave-PIN-Fluss. Bitte fülle die erforderlichen Felder aus',
      noOtp: 'Du hast den OTP noch nicht erhalten. Versuche es erneut, wenn du ihn erhältst',
      wrongOtp: 'Ungültiger Code. Bitte gib den per SMS erhaltenen Code ein',
      haveToReadTerms: 'Du musst die Allgemeinen Geschäftsbedingungen lesen, um fortzufahren',
      phoneError: 'Fehler mit dem Telefon',
      dontHavePhone: 'Ich habe kein anderes Telefon',
      badPhoneSS: 'Die eingegebene Telefonnummer stimmt nicht mit der bei der Sozialversicherung registrierten überein, bitte gib eine andere ein',
      wrongBirthday: 'Geburtsdatum falsch',
      inputBirthDay: 'Bitte gib das Geburtsdatum ein',
      wrongExpiration: 'Ablaufdatum falsch',
      inputExpiration: 'Bitte gib das Ablaufdatum des Dokuments ein',
      duplicatedRequest: 'Doppelte Anfrage!',
      alreadyHaveRequest: 'Es existiert bereits eine Anfrage für diesen Kunden.',
      currentRequestStatus: 'Status der aktuellen Anfrage: ',
      requestNoExist: 'Die Anfrage existiert nicht',
      noRequests: 'Es gibt keine aktiven Anfragen mit dem angegebenen Code',
      needMoreData: 'Wir benötigen weitere Daten, um den Zugang zu öffentlichen Verwaltungen zu prüfen',
    },
    abandoned: {
      afterWaitingOtpSS: 'Abgebrochen nach Warten auf OTP der Sozialversicherung',
      afterInvalidOtpSS: 'Abgebrochen nach ungültigem OTP bei der Sozialversicherung',
      afterInvalidOtpAEAT: 'Abgebrochen nach ungültigem OTP bei der AEAT',
      afterWaitingOtpAEAT: 'Abgebrochen nach Warten auf OTP der AEAT',
    },
    loadings: {
      gettingData: 'Antragsdaten werden abgerufen...',
      resendingOtp: 'OTP wird erneut gesendet...',
      sendingData: 'Daten werden gesendet...',
      validatingData: 'Neue Daten werden validiert, bitte warten...',
      validatingAndLoginSS: 'Daten werden validiert und bei der Sozialversicherung angemeldet, bitte warten...',
      validatingAndLoginAEAT: 'Daten werden validiert und bei der AEAT angemeldet, bitte warten...',
      resendingRequest: 'Anfrage wird erneut gesendet...',
      smsToPin: 'Es wurde eine falsche Telefonnummer erkannt, wir versuchen es über den Clave-PIN-Fluss',
      sendingNewPhone: 'Neue Telefonnummer wird gesendet, bitte warten',
      validatingRequest: 'Anfrage wird validiert, bitte warten...',
      creatingRequest: 'Anfrage wird erstellt, bitte warten',
      cancelingRequest: 'Anfrage wird storniert...',
      checkingSms: 'SMS-Dienst wird überprüft...',
    },
    actions: {
      continue: 'Weiter',
      cancel: 'Prozess abbrechen',
      back: 'Zurück',
      send: 'Senden',
      retry: 'Erneut versuchen',
      resend: 'Erneut senden',
      next: 'Weiter',
      clickToFinish: 'Hier klicken, um abzuschließen',
      newRequest: 'Neue Anfrage',
      gotoCurrentRequest: 'Zur aktuellen Anfrage',
    },
    otp: {
      requestingOtp: 'Wir fordern den Code an. Bitte einen Moment warten.',
      otpSentToNumber: 'Der Code wurde an die Telefonnummer gesendet, die endet auf',
      requestingCode: 'Wir fordern den Code an. Bitte einen Moment warten.',
      noReceivedCode: 'Hast du den Code nicht auf deinem Telefon erhalten?',
      noReceivedCode2: 'Hast du den Code nicht auf dem Telefon erhalten, das endet auf',
      otpCode: 'OTP-Code (per SMS erhalten)',
    },
  }
}




